import ky from 'ky';
import config from '../config';

const API = ky.extend({
  prefixUrl: config.Amplify.API.endpoints[0].endpoint,
  timeout: false
});

export default API;